import request from 'api/request';

export default function updateAccountRoute({ first, last }) {
  return request({ url: '/users', method: 'PUT', data: { first, last } });
}
